module.exports = __webpack_public_path__ + "1cfd67667e764da964f32827343d395a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./docs/todomvc_screenshot.png
 ** module id = 373
 ** module chunks = 0
 **/